<div class="">
	<div *ngIf="employees?.length > 0">
		<div class="form-label theme-main-color fw-bold">
			Intervenants disponibles
		</div>
		<div class="row my-2">
			<!-- <div class="list-group">
				<button
					type="button"
					class="list-group-item list-group-item-action theme-main-color-button"
					*ngFor="let emp of employees"
					[ngClass]="{
						'theme-main-color-check text-white': selectedEmployee === emp
					}"
					(click)="selectEmployee(emp)"
				>
					<span>
						{{
							emp.firstName.slice(0,3) + '.  ' + emp.lastName + ' - ' + emp.address.label + ' - ' + emp.careSkill.name + ' - ' + emp.specialties.toString()
						}}
					</span>
				</button>
			</div> -->
			<div class="list-group">
				<table class="table table-hover">
					<thead>
						<tr>
							<th scope="col">Nom</th>
							<th scope="col">Secteur(s)</th>
							<th scope="col">Expertise(s)</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="let emp of employees"
							(click)="selectEmployee(emp)"
							(keydown)="onKeyDown($event, emp)"
							tabindex="0"
							[ngClass]="{ 'table-primary': selectedEmployee === emp }"
							style="cursor: pointer"
						>
							<td>{{ emp.firstName.slice(0, 3) + '. ' + emp.lastName }}</td>
							<td>{{ getEntityNames(emp.areas) }}</td>
							<!-- <td>{{ getEntityNames(emp.careSkill) }}</td> -->
							<td>{{ getCareSkills(emp.careSkills) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row my-5">
			<!-- <div class="d-flex justify-content-end">
				<button
					class="btn theme-main-color-button mx-3 px-3"
					type="button"
					(click)="bsModalRef.hide()"
				>
					Retour
				</button>
				<button
					[disabled]="!selectedEmployee || isValidateButtonClicked"
					class="btn theme-green-button"
					(click)="validateEmployee()"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div> -->
		</div>
	</div>
</div>
